import { ModalPopup } from "./modal";
import reportIcon from "../../Assets/Icons/paper-load2.svg";
import crossIcon from "../../Assets/Icons/wrong.svg"
import { Button } from "antd";

const GenerateReportModal = ({isGenerateReportModalVisible,setGenerateReportModalVisible,generateReport,children,setIsAllSelectedClicked}) => {
  return <ModalPopup visible={isGenerateReportModalVisible}>
    <div className="top-close-icon" onClick={()=>{setGenerateReportModalVisible(false);setIsAllSelectedClicked(false)}}>
        <img width="20px" src={crossIcon} alt="Close"/>
    </div>
    <div className="Popup-img">
        <img width="40px" style={{marginBlock:"7px"}} src={reportIcon} alt="Report" />
    </div>
    <div className="Popup-content">         
        <span>Select Report Type</span>
        <p>
            Please select the report type to be generated.
        </p>
    </div>
    <div className="ant-modal-footer-section">
        <Button
            key="detailed"
            className="themeBtn-plane"
            style={{paddingRight:"10px"}}
            onClick={() => generateReport("detailed")}
        >Detailed</Button>
        <Button
            key="summary"
            className="themeBtn"
            style={{paddingRight:"10px"}}
            onClick={() => generateReport("summary")}
        >
            Summarised
        </Button>
    </div>
  </ModalPopup>;
};

export default GenerateReportModal;